const addTopContentToPreviewModal = () => {
  document.querySelectorAll(".tee-btn--preview").forEach((button) => {
    button.addEventListener("click", () => {
      const htmlToInsert = `<div class="modal_preview--modify_notice">
                                <p class="modal_preview--title">Please check the preview carefully</p>
                                <p class="modal_preview--notice_content"><em>Make sure the customization is correct to receive your item faster</em></p>
                              </div>`;
      document
        .querySelector(".tee-dialog-gallery .tee-dcontent")
        .insertAdjacentHTML("beforebegin", htmlToInsert);
    });
  });
};

const checkCustomizationModal = () => {
  var hasCustomization = window.teeinblue.hasCustomization(
    window.TeeInBlueCampaign.productId
  );
  const modal = document.getElementById("reset_tib_customizations");

  if (modal && hasCustomization) {
    modal.style.display = "block";

    const closeButtons = document.querySelectorAll("[data-close-modal]");
    const resetButtons = document.querySelectorAll("[data-reset-modal]");
    const confirmButtons = document.querySelectorAll("[data-confirm-reset]");

    closeButtons.forEach((button) =>
      button.addEventListener("click", () => (modal.style.display = "none"))
    );

    resetButtons.forEach((button) =>
      button.addEventListener("click", () => {
        button.disabled = true;
        button.innerHTML =
          '<span class="tee-spinner tee-spinner--sm"><svg xmlns="http://www.w3.org/2000/svg" version="1.0" viewBox="0 0 128 128" class="tee-icon-loading tee-icon-loading--sm"><g><path d="M64 127.75A63.76 63.76 0 0152.8 1.23v14.23a49.8 49.8 0 1022.4 0V1.23A63.76 63.76 0 0164 127.75z"></path><animateTransform attributeName="transform" type="rotate" from="0 64 64" to="360 64 64" dur="1260ms" repeatCount="indefinite"></animateTransform></g></svg></span>';
        window.teeinblue.resetCustomization(window.TeeInBlueCampaign.productId);
        modal.style.display = "none";
      })
    );

    confirmButtons.forEach((button) =>
      button.addEventListener("click", () => {
        button.disabled = true;
        button.innerHTML =
          '<span class="tee-spinner tee-spinner--sm"><svg xmlns="http://www.w3.org/2000/svg" version="1.0" viewBox="0 0 128 128" class="tee-icon-loading tee-icon-loading--sm"><g><path d="M64 127.75A63.76 63.76 0 0152.8 1.23v14.23a49.8 49.8 0 1022.4 0V1.23A63.76 63.76 0 0164 127.75z"></path><animateTransform attributeName="transform" type="rotate" from="0 64 64" to="360 64 64" dur="1260ms" repeatCount="indefinite"></animateTransform></g></svg></span>';
        window.teeinblue.refillCustomization(
          window.TeeInBlueCampaign.productId
        );
        setTimeout(() => {
          modal.style.display = "none";
        }, 500);
      })
    );
  }
};

document.addEventListener("teeinblue-event-component-injected", () => {
  // const elementToMove = document.querySelector(".tee-product-price");
  // const insertAfterElement = document.querySelector(
  //   ".shipping-custom.below-pricing-text"
  // );
  // if (elementToMove && insertAfterElement)
  //   insertAfterElement.before(elementToMove);
  // addTopContentToPreviewModal();
  // checkCustomizationModal();
  // This section was previously used to handle the movement of the product price element
  // to a new location within the product block. The logic ensured that the price element
  // was moved to the top of the target element if both elements were present in the DOM.
  // before it was moved above the shipping info, now it is moved above the price element
  const elementToMove = document.querySelector(".tee-product-price");
  const targetElement = document.querySelector(".product-block--price");
  if (elementToMove && targetElement) targetElement.prepend(elementToMove);
  addTopContentToPreviewModal();
  checkCustomizationModal();
});

document.addEventListener("DOMContentLoaded", () => {
  const elementToMove2 = document.querySelector("#loading_element");
  const insertAfterElement2 = document.querySelector(
    "form.shopify-product-form"
  );
  if (elementToMove2 && insertAfterElement2)
    insertAfterElement2.before(elementToMove2);
});

/* [Product page][SP] Hien thi button Preview khi scroll tren mobile - click vao mo popup Preview - START */
const btnPreviewOnScroll = () => {
  window.onscroll = function () {
    var stickyPreviewBtn = document.querySelector(
      ".pfh-customily-preview-button"
    );
    var teeFormAction = document.querySelector("#teeFormActions");
    var btnPreview =
      teeFormAction.children[1].id === "tee-btn--preview"
        ? teeFormAction.children[1]
        : teeFormAction.children[2];
    var stickyButton = document.querySelector(".pfh-clone-preview-btn");
    var btnPreviewPosition = btnPreview?.getBoundingClientRect();

    if (btnPreviewPosition) {
      if (
        btnPreviewPosition.top <= window.innerHeight &&
        btnPreviewPosition.bottom >= 50
      ) {
        stickyButton.style.opacity = "0";
        stickyButton.parentElement.style.background = "none";
      } else {
        stickyButton.style.opacity = "1";
        stickyButton.parentElement.style.backgroundColor = "#fff";
        stickyButton.style.setProperty(
          "-webkit-text-fill-color",
          "#fff",
          "important"
        );
        stickyButton.style.setProperty("border-color", "#f4993d ", "important");
      }
    }
  };
};

const createPreviewBtn = () => {
  var btnPreview = `<div class="show-mobile-only-sticky-button pfh-customily-preview-button"> <button type="button" class="customily-preview-button ld-over-inverse pfh-clone-preview-btn" data-label="Add to cart" id="customily-preview-button"> <div class="ld ld-cycle ld-ring"></div>Preview</button></div>`;
  document
    .querySelector(".tee-form-wrapper")
    .insertAdjacentHTML("beforebegin", btnPreview);
};

const triggerClickPreviewBtn = () => {
  var stickyPreviewBtn = document.querySelector(
    ".pfh-customily-preview-button"
  );
  var previewBtn = document.querySelector(".tee-form-action .tee-btn--preview");
  if (stickyPreviewBtn && previewBtn) {
    stickyPreviewBtn.addEventListener("click", () => {
      var confirmedInput = document.querySelector('input[name="confirmed"]');
      if (confirmedInput) {
        previewBtn.click();
        if (!confirmedInput.checked) {
          confirmedInput.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          setTimeout(() => {
            const htmlToInsert = `<div class="modal_preview--modify_notice">
                    <p class="modal_preview--title">Please check the preview carefully</p>
                    <p class="modal_preview--notice_content"><em>Make sure the customization is correct to receive your item faster</em></p>
                  </div>`;
            document
              .querySelector(".tee-dialog-gallery .tee-dcontent")
              ?.insertAdjacentHTML("beforebegin", htmlToInsert);
          }, 50);
        }
      } else {
        previewBtn.click();
        setTimeout(() => {
          const htmlToInsert = `<div class="modal_preview--modify_notice">
                  <p class="modal_preview--title">Please check the preview carefully</p>
                  <p class="modal_preview--notice_content"><em>Make sure the customization is correct to receive your item faster</em></p>
                </div>`;
          document
            .querySelector(".tee-dialog-gallery .tee-dcontent")
            ?.insertAdjacentHTML("beforebegin", htmlToInsert);
        }, 50);
      }
    });
  }
};

document.addEventListener("teeinblue-event-component-injected", () => {
  createPreviewBtn();
  btnPreviewOnScroll();
  triggerClickPreviewBtn();
});
/* [Product page][SP] Hien thi button Preview khi scroll tren mobile - click vao mo popup Preview - END */

// Thay description content
const replaceDescContent = () => {
  if (!window.TIBOverrideDesc) return;

  setTimeout(() => {
    const teeDescriptionContent = document.querySelector(
      ".tee-description__content"
    );
    const targetDiv = document.querySelector(
      '.product-tabs__panel[tabindex="0"] .rte'
    );
    if (teeDescriptionContent && targetDiv) {
      targetDiv.innerHTML = teeDescriptionContent.innerHTML;
    }
  }, 300);
};

document.addEventListener("teeinblue-event-component-injected", () => {
  replaceDescContent();
});

document.addEventListener("teeinblue-event-variant-changed", () => {
  replaceDescContent();
});

/* [Product Page] KiwiSizingChart - START */
const checkKiwiSizingChart = () => {
  var kiwiSizingChart = document.querySelector(
    "#KiwiSizingChart .ks-chart-modal-link"
  );
  var teeOptionTitle = document.querySelector(
    ".tee-option--size .tee-option__title"
  );
  if (kiwiSizingChart && teeOptionTitle) {
    var existingClone = teeOptionTitle.querySelector(".ks-chart-modal-link");
    if (!existingClone) {
      var kiwiSizingChartClone = kiwiSizingChart.cloneNode(true);
      teeOptionTitle.appendChild(kiwiSizingChartClone);
      kiwiSizingChartClone.addEventListener("click", function () {
        kiwiSizingChart.click();
      });
    }
  }
};
document.addEventListener(
  "teeinblue-event-variant-changed",
  checkKiwiSizingChart
);
document.addEventListener("teeinblue-event-component-injected", () => {
  const checkElementRendered = setInterval(() => {
    if (document.querySelector("#KiwiSizingChart .ks-chart-modal-link")) {
      checkKiwiSizingChart();
      clearInterval(checkElementRendered);
    }
  }, 1000);
  document
    .querySelectorAll(".tee-available-products .tee-radio")
    .forEach((radio) => {
      radio.addEventListener("click", () => {
        setTimeout(() => {
          checkKiwiSizingChart();
        }, 200);
      });
    });
});
/* [Product Page] KiwiSizingChart - END */

/* [Product Page] Gallery Custom - START */

/* update 04042024 */

initGallery = (flkty) => {
  var currentIndex = $(".tee-thumbnail--active").index(".tee-thumbnail");
  flkty.select(currentIndex);

  let prevButton = document.querySelector(".tee-slider__button--prev");
  let nextButton = document.querySelector(".tee-slider__button--next");

  let oldX = 0;

  $(".tee-slider__track").on(
    "dragStart.flickity",
    (event, { pageX }) => (oldX = pageX)
  );

  $(".tee-slider__track").on("dragEnd.flickity", (event, { pageX }) => {
    const diff = pageX - oldX;
    const button = diff < 0 ? nextButton : prevButton;
    if (button) button.click();
  });

  $(".flickity-prev-next-button.previous").on("click", (event) => {
    if (prevButton) {
      prevButton.click();
    }
  });
  $(".flickity-prev-next-button.next").on("click", (event) => {
    if (nextButton) {
      nextButton.click();
    }
  });

  handleThumbnailButtonClick = (event) => {
    var currentIndex = $(".tee-thumbnail--active").index(".tee-thumbnail");
    if (flkty.selectedIndex != currentIndex) {
      flkty.select(currentIndex);
    }
  };

  handleInputChange = (event) => {
    // $('.tee-field--clipart .tee-clipart-label').on("click", handleInputChange);
    // $('.tee-custom-select-item').on("click", handleInputChange);
    var currentIndex = $(".tee-thumbnail--active").index(".tee-thumbnail");
    if (flkty.selectedIndex != currentIndex) {
      flkty.select(currentIndex);
    }
  };

  $(".tee-thumbnails__button--prev").on("click", handleThumbnailButtonClick);
  $(".tee-thumbnails__button--next").on("click", handleThumbnailButtonClick);
  $(".tee-field--clipart .tee-clipart-label").on("click", handleInputChange);
  $(".tee-custom-select-item").on("click", handleInputChange);
  $("#teeFormInputs").on(
    "input change",
    'input[type="text"], input[type="checkbox"], input[type="radio"], select',
    handleInputChange
  );
};

document.addEventListener("teeinblue-event-component-injected", () => {
  const checkElementRendered = setInterval(() => {
    var teeSlider = document.querySelector(
      ".product__images .tee-gallery-content .tee-slider__track"
    );
    if (teeSlider) {
      if (!teeSlider.classList.contains("flickity-enabled")) {
        var flkty = new Flickity(teeSlider, {
          wrapAround: true,
          adaptiveHeight: true,
          dragThreshold: 10,
          imagesLoaded: true,
          pageDots: false,
          watchCSS: false,
        });

        $(".tee-thumbnail").on("click", (event) => {
          const index = $(event.currentTarget).index();
          flkty.select(index);
        });

        initGallery(flkty);
      }
      clearInterval(checkElementRendered);
    } else {
      console.log("Waiting for #tee-gallery to render...");
    }
  }, 1000);
});

document.addEventListener("teeinblue-event-variant-changed", () => {
  var teeSlider = document.querySelector(
    ".product__images .tee-gallery-content .tee-slider__track"
  );
  $(".product__images .tee-gallery-content .tee-slider__track")
    .flickity()
    .flickity("destroy");

  setTimeout(() => {
    var teeSlider = document.querySelector(
      ".product__images .tee-gallery-content .tee-slider__track"
    );
    if (!teeSlider) return;

    var flkty = new Flickity(teeSlider, {
      wrapAround: true,
      adaptiveHeight: true,
      dragThreshold: 10,
      imagesLoaded: true,
      pageDots: false,
      watchCSS: false,
    });

    $(".tee-thumbnail").on("click", (event) => {
      const index = $(event.currentTarget).index();
      flkty.select(index);
    });

    var currentIndex = $(".tee-thumbnail--active").index(".tee-thumbnail");
    flkty.select(currentIndex);
    initGallery(flkty);
  }, 500);
});

/* [Product Page] Gallery Draggable - END */
